export default __webpack_public_path__ + "static/media/twitterIcon.6e62a7d8.PNG";